<div class="row">
    <div class="col-sm-12">
        <div class="row" *ngIf="viewType != 'contract'">
            <div class="col-sm-11">
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Order #:</label>
                                {{searchQuoteOrderLine.quoteOrderID}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" *ngIf="searchQuoteOrderLine.orderNumber!=searchQuoteOrderLine.quoteOrderID">
                                <label class="fw-bold">Ext #:</label>
                                {{searchQuoteOrderLine.orderNumber}}
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <span class="align-top">
                                    <label class="fw-bold">Priority:</label>
                                    {{searchQuoteOrderLine.quoteOrderLinePriorityAbbrev}}
                                </span>
                                <rate-index-indicator [rateIndexID]="searchQuoteOrderLine.rateIndexID" [rateIndexName]="searchQuoteOrderLine.rateIndex"></rate-index-indicator>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">RT:</label>
                                {{searchQuoteOrderLine.isRoundTrip==true?"Yes":"No"}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">No Track:</label>
                                {{searchQuoteOrderLine.isDoNotTrack==true?"Yes":"No"}}
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Trailer:</label>
                                {{searchQuoteOrderLine.trailer}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Size:</label>
                                {{searchQuoteOrderLine.trailerSize > 0 ? searchQuoteOrderLine.trailerSize : ""}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Miles:</label>
                                {{searchQuoteOrderLine.miles}}
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Max Pay:</label>
                                {{searchQuoteOrderLine.maxCarrierPay | currency}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Price:</label>
                                {{searchQuoteOrderLine.price | currency}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Target:</label>
                                {{searchQuoteOrderLine.targetCost | currency}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 m-1 p-1 border border-warning rounded" *ngIf="canShowConvoy()">
                        <div class="row">
                            <div class="col">
                                <h3 class="text-success">Convoy : {{convoyLoad.postingStatus}}</h3>
                            </div>
                            <div class="col text-end">
                                <button type="button" class="btn btn-sm btn-secondary m-1" (click)="viewConvoyError()">View Detail</button>
                                <button type="button" class="btn btn-sm btn-danger m-1" (click)="cancelConvoy()" *ngIf="canCancelConvoy()">Cancel</button>
                                <button type="button" class="btn btn-sm btn-danger m-1" (click)="uncancelConvoy()" *ngIf="canUncancelConvoy()">Uncancel</button>
                                <button type="button" class="btn btn-sm btn-primary m-1" (click)="updateConvoy()" [disabled]="convoyMaxBuyRate <= 0 || convoyAutoAcceptRate <= 0 || convoyLoad.postingStatus == 'CANCELED'">Update</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Max Buy Rate:</label>
                                <input class="form-control" type="number" [(ngModel)]="convoyMaxBuyRate" min="0" step="0.01" [disabled]="convoyLoad.postingStatus == 'CANCELED'" />
                            </div>
                            <div class="col">
                                <label class="fw-bold">Auto Accept Rate:</label>
                                <input class="form-control" type="number" [(ngModel)]="convoyAutoAcceptRate" min="0" step="0.01" [disabled]="convoyLoad.postingStatus == 'CANCELED'" />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 m-1 p-1 border border-success rounded">
                        <div class="row">
                            <div class="col">
                                <h3 class="text-success">Greenscreens</h3>
                            </div>
                            <div class="col text-end">
                                <button type="button" class="btn btn-sm btn-primary m-1" (click)="updateGreenscreens()">Update</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Target Buy:</label>
                                {{gsRate.targetBuyRate | currency}}
                            </div>
                            <div class="col">
                                <label class="fw-bold">Start Buy:</label>
                                {{gsRate.startBuyRate | currency}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Conf Lvl:</label>
                                {{gsRate.confidenceLevel}}
                            </div>
                            <div class="col">
                                <label class="fw-bold">Date:</label>
                                {{gsRate.createdDate | date:'shortDate'}}
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 m-1 p-1 border border-primary rounded">
                        <h3 class="text-primary">DAT</h3>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Mid Rate:</label>
                                {{searchQuoteOrderLine.spotAverageRate | currency}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Low Rate:</label>
                                {{searchQuoteOrderLine.spotLowRate | currency}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="isShowConvoyLoadError">
                    <div class="col border border-warning rounded">
                        <h3 class="text-success">Convoy Response</h3>
                        <div class="row">
                            <div class="col">
                                <kendo-grid [kendoGridBinding]="convoyResponse.loads!">
                                    <kendo-grid-column *ngFor="let item of elementsMeta"
                                                       field="{{item.columnField}}"
                                                       title="{{item.columnTitle}}">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            {{getConvoyValue(dataItem)}}
                                        </ng-template>
                                    </kendo-grid-column>
                                </kendo-grid>
                            </div>
                            <div class="col-sm-1">
                                <button type="button" class="btn btn-sm btn-secondary m-1" (click)="viewConvoyError()">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-7" *ngIf="false">
                <div class="row" *ngIf="editedCarrierList">
                    <div class="col fw-bold text-end">Carrier:</div>
                    <div class="col-sm-2">
                        <a target="_blank" [routerLink]="['/carrier-detail', editedCarrierList.carrierCode, searchQuoteOrderLine.opportunityID]">
                            {{editedCarrierList.carrierCode}}
                        </a><br />
                        <a target="_blank" [routerLink]="['/carrier-detail', editedCarrierList.carrierCode, searchQuoteOrderLine.opportunityID]">
                            {{editedCarrierList.carrierName}}
                        </a><br />
                        {{editedCarrierList.carrierCity}}, {{editedCarrierList.carrierState}}
                    </div>
                    <div class="col-sm-2">
                        <div *ngIf="editedCarrierList.mcNumber.startsWith('MC')">
                            <label class="fw-bold">MC:</label>
                            {{editedCarrierList.mcNumber}}
                        </div>
                        <div *ngIf="editedCarrierList.dotNumber!=null">
                            <label class="fw-bold">DOT:</label>
                            {{editedCarrierList.dotNumber}}
                        </div>
                        <div *ngIf="editedCarrierList.mcNumber.startsWith('MX')">
                            <label class="fw-bold">MX:</label>
                            {{editedCarrierList.mcNumber}}
                        </div>
                        <div *ngIf="editedCarrierList.scacNumber!=null&&editedCarrierList.scacNumber!=''">
                            <label class="fw-bold">SCAC:</label>
                            {{editedCarrierList.scacNumber}}
                        </div>
                    </div>
                    <div class="col">
                        <label class="fw-bold">Procurements:</label>
                        {{editedCarrierList.procurements }}
                    </div>
                    <div class="col">
                        <label class="fw-bold">Last Offer:</label>
                        {{editedCarrierList.lastOfferRate | currency}}
                    </div>
                    <div class="col">
                        <label class="fw-bold">Last Rate:</label>
                        {{editedCarrierList.extendedRate | currency}}
                    </div>
                    <div class="col">
                        <label class="fw-bold">Last Date:</label>
                        {{editedCarrierList.lastRan | date:'shortDate'}}
                    </div>
                    <div class="col fw-bold text-end">Min Rate:</div>
                    <div class="col">
                        {{editedCarrierList.minRate > 0 ? (editedCarrierList.minRate | currency) : ''}}<br />
                        {{editedCarrierList.minRate > 0 ? (editedCarrierList.minRateDate | date:'shortDate') : ''}}
                    </div>
                </div>
            </div>
            <div class="col text-end" *ngIf="isBulkTender!=true">
                <button type="button" (click)="getCarriers();getQuoteOrderLine();" class="btn btn-success">
                    <span class="fas fa-sync" aria-hidden="true"></span> Refresh
                </button>
            </div>
        </div>
        <div class="row" style="margin-bottom:10px;" *ngIf="viewType != 'contract'">
            <div class="col-sm-2">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Acct Mgr:</label>
                        {{searchQuoteOrderLine.accountManagerName}}
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Ops Rep:</label>
                        {{searchQuoteOrderLine.opsRepName}}
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <label class="fw-bold" style="display: block">Internal Notes</label>
                <kendo-textarea style="width:100%" id="internalNotes"
                                resizable="auto"
                                [(ngModel)]="quoteOrder.internalNotes"
                                [value]="quoteOrder.internalNotes">
                </kendo-textarea>
            </div>
            <div class="col-sm-3">
                <label class="fw-bold" style="display: block">External Notes</label>
                <kendo-textarea style="width:100%" id="externalNotes"
                                resizable="auto"
                                [(ngModel)]="quoteOrder.externalNotes"
                                [value]="quoteOrder.externalNotes">
                </kendo-textarea>
            </div>
            <div class="col">
                <customer-notes [billToID]="searchQuoteOrderLine.billToCustomerID" [shipperID]="searchQuoteOrderLine.shipperCustomerID" [consigneeID]="searchQuoteOrderLine.consigneeCustomerID"></customer-notes>
            </div>
            <div class="col-sm-1 text-end align-self-end">
                <input type="button" class="btn btn-primary" value="Save" (click)="saveQuoteOrderNotes()" *ngIf="searchQuoteOrderLine.quoteOrderLineTypeAbbrev=='ORD'||searchQuoteOrderLine.quoteOrderLineTypeAbbrev=='CG'" />
                <input type="button" class="btn btn-primary" value="Save" (click)="saveQuoteOrderLineComments()" *ngIf="searchQuoteOrderLine.quoteOrderLineTypeAbbrev!='ORD'&&searchQuoteOrderLine.quoteOrderLineTypeAbbrev!='CG'" />
            </div>
        </div>
        <div class="row" *ngIf="viewType != 'contract'">
            <div class="col">
                <label class="fw-bold" style="display: block">Tags</label>
                <tagmap-list [isForOrder]="true" [recordID]="searchQuoteOrderLine.quoteOrderID"></tagmap-list>
            </div>
        </div>
        <kendo-tabstrip (tabSelect)="onTabSelect($event)" #tabStrip>
            <kendo-tabstrip-tab [title]="'Carriers by Geocode'" *ngIf="isBulkTender!=true" [selected]="!isBulkTender">
                <ng-template kendoTabContent>
                    <div class="row" *ngIf="isBulkTender!=true">
                        <div class="p-0 col-sm-12 text-nowrap overflow-auto">
                            <span *ngFor="let rank of rankList">
                                <span class="btn btn-secondary m-1 p-1" (click)="toggleRank(rank)">
                                    <span class="badge text-dark bg-light">{{rank.total}}</span>
                                    {{rank.rankName}}
                                    <input type="checkbox" style="margin:10px;transform: scale(1.5);"
                                           [id]="rank.rankAbbrev" [name]="rank.rankAbbrev"
                                           [checked]="rank.isShow"
                                           autocomplete="off" />
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <kendo-grid #carriersGrid
                                        [data]="gridData"
                                        [pageSize]="gridState.take"
                                        [skip]="gridState.skip"
                                        [sort]="gridState.sort"
                                        [filter]="gridState.filter"
                                        [sortable]="true"
                                        [pageable]="true"
                                        [filterable]="true"
                                        [resizable]="true"
                                        [autoSize]="true"
                                        [rowClass]="rowCallback"
                                        (dataStateChange)="dataStateChange($event)"
                                        (edit)="editHandler($event)"
                                        (cancel)="cancelHandler($event)"
                                        (save)="saveHandler($event)">
                                <kendo-grid-command-column title="Action">
                                    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
                                        <button type="button" class="btn btn-primary" (click)="addOffer(dataItem)" *ngIf="dataItem.customerExcluded!=true">{{dataItem.offerId > 0 || dataItem.offerRate > 0 ? 'Edit' : 'Add'}} Offer</button>
                                        <label class="text text-danger fw-bold" *ngIf="dataItem.customerExcluded==true">Customer Excluded</label>
                                        <button kendoGridSaveCommand type="button" [primary]="true" [disabled]="isSaving==true">Save</button>
                                        <button kendoGridCancelCommand type="button">Cancel</button>
                                        <button *ngIf="!editedCarrierList&&dataItem.customerExcluded!=true" type="button" class="btn btn-secondary m-1" (click)="sendCarrierEmail(dataItem, true)">Email</button>
                                    </ng-template>
                                </kendo-grid-command-column>
                                <kendo-grid-column field="confidenceRanking" title="Rank">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <h3 class="badge bg-primary">{{dataItem.confidenceRanking}}</h3>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="source" title="Src"></kendo-grid-column>
                                <kendo-grid-column field="carrierTeam" title="Team"></kendo-grid-column>
                                <kendo-grid-column filter="offerRate" title="Rate">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.offerRate | currency}}
                                    </ng-template>
                                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                        <strong>Rate:</strong> <input [(ngModel)]="dataItem.offerRate" (change)="dataItem.offerRatePerMile=calculateOfferRatePerMile(dataItem.offerRate)" kendoGridFocusable name="offerRate" class="form-control k-input" type="number" step="0.01" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column filter="offerRatePerMile" title="Rate/mi">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.offerRatePerMile | currency}}/mi
                                    </ng-template>
                                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                        <strong>Rate/mi:</strong> <input [(ngModel)]="dataItem.offerRatePerMile" (change)="dataItem.offerRate=calculateOfferRate(dataItem.offerRatePerMile)" kendoGridFocusable name="offerRatePerMile" class="form-control k-input" type="number" step="0.01" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column filter="fuelCost" title="Fuel" *ngIf="searchQuoteOrderLine.quoteOrderLineTypeDesc=='RFQ'">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.fuelCost | currency}}
                                    </ng-template>
                                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                        <strong>Fuel:</strong> <input [(ngModel)]="dataItem.fuelCost" (change)="dataItem.fuelCostPerMile=calculateFuelCostPerMile(dataItem.fuelCost)" kendoGridFocusable name="fuelCost" class="form-control k-input" type="number" step="0.01" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column filter="fuelCostPerMile" title="Fuel/mi" *ngIf="searchQuoteOrderLine.quoteOrderLineTypeDesc=='RFQ'">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.fuelCostPerMile | currency}}
                                    </ng-template>
                                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                        <strong>Fuel/mi:</strong> <input [(ngModel)]="dataItem.fuelCostPerMile" (change)="dataItem.fuelCost=calculateFuelCost(dataItem.fuelCostPerMile)" kendoGridFocusable name="fuelCostPerMile" class="form-control k-input" type="number" step="0.01" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="emailed" title="Emailed">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.emailed ? 'Yes' : 'No'}}
                                    </ng-template>
                                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                        <input type="checkbox" [checked]="dataItem.emailed" (change)="dataItem.emailed = !dataItem.emailed" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="declined" title="Declined">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.declined ? 'Yes' : 'No'}}
                                    </ng-template>
                                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                        <input type="checkbox" [checked]="dataItem.declined" (change)="dataItem.declined = !dataItem.declined" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="contacted" title="Contacted">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.contacted ? 'Yes' : 'No'}}
                                    </ng-template>
                                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                        <input type="checkbox" [checked]="dataItem.contacted||dataItem.offerRate>0||dataItem.offerRatePerMile>0" (change)="dataItem.contacted = !dataItem.contacted" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="carrierCode" title="Carrier 3x3">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <rmis-status [rmisStatusColor]="dataItem.rmisStatusColor" [rmisStatusTextColor]="dataItem.rmisStatusTextColor" [rmisStatusAbbrev]="dataItem.rmisStatusAbbrev" [rmisStatusTooltip]="dataItem.nonCertifiedReasons"></rmis-status>
                                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode, dataItem.opportunityID]">
                                            {{dataItem.carrierCode}}
                                        </a>
                                    </ng-template>
                                </kendo-grid-column>
                                <!--<kendo-grid-column field="rmisCertifiedColor" title="RMIS">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span title="{{dataItem.rmisStatus}}" class="badge rounded-pill border border-dark" [ngClass]="'bg-' + dataItem.rmisCertifiedColor">
                &nbsp;
            </span>
        </ng-template>
    </kendo-grid-column>-->
                                <kendo-grid-column field="carrierName" title="Carrier Name">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode, searchQuoteOrderLine.opportunityID]">
                                            {{dataItem.carrierName}}
                                        </a>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="carrierCity" title="City"></kendo-grid-column>
                                <kendo-grid-column field="carrierState" title="ST"></kendo-grid-column>
                                <kendo-grid-column field="procurements" title="Cnt"></kendo-grid-column>
                                <kendo-grid-column field="lastOfferRate" title="Last Offer">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.lastOfferRate | currency}}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="extendedRate" title="Last Rate">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.extendedRate | currency}}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="lastRan" title="Last Date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.lastRan | date:'shortDate'}}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="minRate" title="Min Rate">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.minRate > 0 ? (dataItem.minRate | currency) : ''}}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="minRate" title="Min Date">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.minRate > 0 ? (dataItem.minRateDate | date:'shortDate') : ''}}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="preferred" title="Preferred">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.preferred ? 'Yes' : 'No'}}
                                    </ng-template>
                                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                        <input type="checkbox" [checked]="dataItem.declined" (change)="dataItem.declined = !dataItem.declined" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="preferredSetBy" title="Set By"></kendo-grid-column>
                            </kendo-grid>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Search'" *ngIf="isBulkTender!=true">
                <ng-template kendoTabContent>
                    <div class="row">
                        <div class="col">
                            <h2>Domiciled</h2>
                            <div class="row">
                                <div class="col-sm-8">
                                    <label class="fw-bold">Origin</label>
                                    <select class="form-select" [(ngModel)]="searchCarrierListCriteria.domiciledOrigin" (change)="domiciledChange($event,'origin')">
                                        <option></option>
                                        <option value="Zip3">Zip3 (0-50 miles)</option>
                                        <option value="Market">Market (51-250 miles)</option>
                                        <option value="Expanded Market">Expanded Market (251-500 miles)</option>
                                        <option value="Region">Region (500+ miles)</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-8">
                                    <label class="fw-bold">Destination</label>
                                    <select class="form-select" [(ngModel)]="searchCarrierListCriteria.domiciledDestination" (change)="domiciledChange($event,'destination')">
                                        <option></option>
                                        <option value="Zip3">Zip3 (0-50 miles)</option>
                                        <option value="Market">Market (51-250 miles)</option>
                                        <option value="Expanded Market">Expanded Market (251-500 miles)</option>
                                        <option value="Region">Region (500+ miles)</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row">
                                <div class="col-sm-3">
                                    <h2>Equipment</h2>
                                </div>
                                <div class="col-sm-4">
                                    <select name="equipmentClassID" [(ngModel)]="equipmentClassID" class="form-select" (change)="equipmentClassChange($event)">
                                        <option value="0">Select Class</option>
                                        <option *ngFor="let item of equipmentClassList" value="{{item.equipmentClassID}}">[{{item.abbreviation}}] {{item.className}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-8">
                                    <div style="margin:5px;height:150px;overflow:scroll;border:1px solid #ccc;">
                                        <table>
                                            <tr *ngFor="let item of filteredTrailerEquipmentClassList">
                                                <td><input type="checkbox" [(ngModel)]="item.isChecked" [checked]="item.isChecked" style="margin:5px;transform: scale(1.5);" /></td>
                                                <td (click)="item.isChecked=!item.isChecked">{{item.trailerTypeAbbrev}}</td>
                                                <td (click)="item.isChecked=!item.isChecked">{{item.trailerTypeDescription}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <h2>Services</h2>
                            <div class="row">
                                <div class="col-sm-8">
                                    <div style="margin:5px;height:150px;overflow:scroll;border:1px solid #ccc;">
                                        <table>
                                            <tr *ngFor="let item of carrierServiceList">
                                                <td><input type="checkbox" [(ngModel)]="item.isChecked" [checked]="item.isChecked" style="margin:5px;transform: scale(1.5);" /></td>
                                                <td (click)="item.isChecked=!item.isChecked">{{item.abbreviation}}</td>
                                                <td (click)="item.isChecked=!item.isChecked">{{item.description}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button (click)="getSearchCarrierList()" class="btn btn-primary" title="Search">Search</button>
                            <button (click)="clearSearchCarrierList()" class="btn btn-secondary m-2" title="Search">Clear</button>
                        </div>
                        <div class="col-sm-2">
                            <h2 class="text-primary">Results: {{filteredSearchCarriers.length}} Carriers</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <kendo-grid #carriersSearchGrid
                                        [data]="searchGridData"
                                        [pageSize]="searchGridState.take"
                                        [skip]="searchGridState.skip"
                                        [sort]="searchGridState.sort"
                                        [filter]="searchGridState.filter"
                                        [sortable]="true"
                                        [pageable]="true"
                                        [filterable]="true"
                                        [resizable]="true"
                                        (dataStateChange)="searchDataStateChange($event)"
                                        (edit)="editHandler($event)"
                                        (cancel)="cancelHandler($event)"
                                        (save)="saveHandler($event)">
                                <kendo-grid-command-column title="Action" width="115">
                                    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
                                        <button type="button" class="btn btn-primary" (click)="addOffer(dataItem)" *ngIf="dataItem.customerExcluded!=true">{{dataItem.offerId > 0 || dataItem.offerRate > 0 ? 'Edit' : 'Add'}} Offer</button>
                                        <label class="text text-danger fw-bold" *ngIf="dataItem.customerExcluded==true">Customer Excluded</label>
                                        <button kendoGridSaveCommand type="button" [primary]="true" [disabled]="isSaving==true">Save</button>
                                        <button kendoGridCancelCommand type="button">Cancel</button>
                                        <button *ngIf="!editedCarrierList&&dataItem.customerExcluded!=true" type="button" class="btn btn-secondary m-1" (click)="sendCarrierEmail(dataItem, true)">Email</button>
                                    </ng-template>
                                </kendo-grid-command-column>
                                <kendo-grid-column field="carrierCode" title="Carrier 3x3" width="150">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <rmis-status [rmisStatusColor]="dataItem.rmisStatusColor" [rmisStatusTextColor]="dataItem.rmisStatusTextColor" [rmisStatusAbbrev]="dataItem.rmisStatusAbbrev" [rmisStatusTooltip]="dataItem.nonCertifiedReasons"></rmis-status>
                                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode, searchQuoteOrderLine.opportunityID]">
                                            {{dataItem.carrierCode}}
                                        </a><br />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="carrierCode" title="Carrier Name" width="200">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode, searchQuoteOrderLine.opportunityID]">
                                            {{dataItem.carrierName}}
                                        </a>
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="carrierCity" title="City" width="150"></kendo-grid-column>
                                <kendo-grid-column field="carrierState" title="State" width="75"></kendo-grid-column>
                            </kendo-grid>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Carrier Offer'" *ngIf="isBulkTender!=true">
                <ng-template kendoTabContent>
                    <div class="row">
                        <div class="col-sm-1 text-end fw-bold">
                            {{carrierLookupType}}:
                        </div>
                        <div class="col-sm-2">
                            <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupControl'" [placeholder]="'Enter ' + carrierLookupType"
                                              [carrierLookupType]="carrierLookupType" (carrierSelected)="onCarrierChange($event)" [isDisabled]="carrierOfferBatchID>=0"></carrier-dropdown>
                            <strong class="text text-danger" *ngIf="isDATLookup()">
                                {{carrierLookupType}}# not found. Click the DAT lookup to populate this carrier.
                            </strong>
                        </div>
                        <div class="col-sm-2">
                            <!--<button (click)="checkCarrierLookupValue()" class="btn btn-sml btn-warning" title="Check Value"><i class="fas fa-check"></i></button>-->
                            <button (click)="addCarrier()" class="btn btn-sml btn-primary" title="Add Carrier" [disabled]="carrierOfferBatchID>=0"><i class="fas fa-plus"></i></button>
                            <button (click)="getDATCarrierByNumber()" class="btn btn-sml btn-success m-1" title="Import From DAT" *ngIf="(carrierLookupType=='MC'||carrierLookupType=='DOT')&&isDATLookup()" [disabled]="carrierOfferBatchID>=0"><i class="fas fa-cloud-download-alt"></i> DAT</button>
                        </div>
                        <div class="col fw-bold">
                            <input type="radio" id="carrierLookupMC" name="carrierLookupType" [value]="'MC'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='MC'" [disabled]="carrierOfferBatchID>=0" (click)="getCarrierLookup('MC')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupMC">MC</label>
                            <input type="radio" id="carrierLookupCode" name="carrierLookupType" [value]="'Code'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='Code'" [disabled]="carrierOfferBatchID>=0" (click)="getCarrierLookup('Code')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupCode">Code</label>
                            <input type="radio" id="carrierLookupName" name="carrierLookupType" [value]="'Name'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='Name'" [disabled]="carrierOfferBatchID>=0" (click)="getCarrierLookup('Name')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupName">Name</label>
                            <input type="radio" id="carrierLookupDOT" name="carrierLookupType" [value]="'DOT'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='DOT'" [disabled]="carrierOfferBatchID>=0" (click)="getCarrierLookup('DOT')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupDOT">DOT</label>
                            <input type="radio" id="carrierLookupMX" name="carrierLookupType" [value]="'MX'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='MX'" [disabled]="carrierOfferBatchID>=0" (click)="getCarrierLookup('MX')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupMX">MX</label>
                            <input type="radio" id="carrierLookupSCAC" name="carrierLookupType" [value]="'SCAC'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='SCAC'" [disabled]="carrierOfferBatchID>=0" (click)="getCarrierLookup('SCAC')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupSCAC">SCAC</label>
                        </div>
                    </div>
                    <div class="row p-2" *ngIf="isAddCarrier">
                        <div class="col border border-primary bg-light">
                            <carrier-quick-add [countryCode]="countryCode" (onRefreshCarrier)="onCarrierChange($event)"></carrier-quick-add>
                        </div>
                    </div>
                    <div class="row" *ngIf="editedCarrierList && (editedCarrierList | json) != '{}'">
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <!--<carrier-geocodelane-detail [carrierID]="editedCarrierList.carrierId" (onRefresh)="onCarrierChange($event)"></carrier-geocodelane-detail>-->
                                    <carrier-geocodelane-detail [carrierID]="editedCarrierList.carrierId" [carrier]="editedCarrierList" (onRefresh)="onCarrierChange($event)"></carrier-geocodelane-detail>
                                </div>
                            </div>
                            <div class="row p-1">
                                <div class="col-sm-3 fw-bold text-end">Rate</div>
                                <div class="col">
                                    <input [(ngModel)]="editedCarrierList.offerRate" (change)="editedCarrierList.offerRatePerMile=calculateOfferRatePerMile(editedCarrierList.offerRate)" name="offerRate" class="form-control k-input" type="number" step="0.01" />
                                </div>
                            </div>
                            <div class="row p-1">
                                <div class="col-sm-3 fw-bold text-end">Rate/mi</div>
                                <div class="col">
                                    <input [(ngModel)]="editedCarrierList.offerRatePerMile" (change)="editedCarrierList.offerRate=calculateOfferRate(editedCarrierList.offerRatePerMile)" name="offerRatePerMile" class="form-control k-input" type="number" step="0.01" />
                                </div>
                            </div>
                            <div class="row p-1" *ngIf="searchQuoteOrderLine.quoteOrderLineTypeDesc=='RFQ'">
                                <div class="col-sm-3 fw-bold text-end">Fuel</div>
                                <div class="col">
                                    <input [(ngModel)]="editedCarrierList.fuelCost" (change)="editedCarrierList.fuelCostPerMile=calculateFuelCostPerMile(editedCarrierList.fuelCost)" name="fuelCost" class="form-control k-input" type="number" step="0.01" />
                                </div>
                            </div>
                            <div class="row p-1" *ngIf="searchQuoteOrderLine.quoteOrderLineTypeDesc=='RFQ'">
                                <div class="col-sm-3 fw-bold text-end">Fuel/mi</div>
                                <div class="col">
                                    <input [(ngModel)]="editedCarrierList.fuelCostPerMile" (change)="editedCarrierList.fuelCost=calculateFuelCost(editedCarrierList.fuelCostPerMile)" name="fuelCostPerMile" class="form-control k-input" type="number" step="0.01" />
                                </div>
                            </div>
                            <div class="row p-1">
                                <div class="col-sm-3 fw-bold text-end">Comments</div>
                                <div class="col">
                                    <textarea style="width:80%" class="form-control" rows="5" [(ngModel)]="editedCarrierList.commentText"></textarea>
                                </div>
                            </div>
                            <div class="row p-1">
                                <div class="col-sm-3 fw-bold text-end">Contact</div>
                                <div class="col">
                                    <input type="checkbox" style="margin:10px;transform: scale(1.5);" [checked]="editedCarrierList.emailed" (change)="editedCarrierList.emailed = !editedCarrierList.emailed" />
                                    <label class="fw-bold">Emailed</label><br />
                                    <input type="checkbox" style="margin:10px;transform: scale(1.5);" [checked]="editedCarrierList.declined" (change)="editedCarrierList.declined = !editedCarrierList.declined" />
                                    <label class="fw-bold">Declined</label><br />
                                    <input type="checkbox" style="margin:10px;transform: scale(1.5);" [checked]="editedCarrierList.contacted||editedCarrierList.offerRate>0||editedCarrierList.offerRatePerMile>0" (change)="editedCarrierList.contacted = !editedCarrierList.contacted" />
                                    <label class="fw-bold">Contacted</label><br />
                                    <!--<strong>Preferred:</strong> <input type="checkbox" [checked]="editedCarrierList.preferred" (change)="editedCarrierList.preferred = !editedCarrierList.preferred" />-->
                                </div>
                            </div>
                            <div class="row p-1">
                                <div class="col text-end">
                                    <label class="text-danger k-fw-bold k-display-block" *ngIf="isCustomerExcluded==true">Customer Excluded</label>
                                    <button class="btn btn-primary" type="button" (click)="saveOffer(false)" [disabled]="isSaving == true" *ngIf="isCustomerExcluded != true">Save</button>
                                    <button class="btn btn-primary m-1" type="button" (click)="saveOffer(true)" [disabled]="isSaving == true" *ngIf="isCustomerExcluded != true && viewType != 'contract'">Save and Continue Sales</button>
                                    <button class="btn btn-secondary" (click)="cancelOffer()">Cancel</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-sm-12">
                                    <kendo-tabstrip>
                                        <kendo-tabstrip-tab [title]="'Contacts'" [selected]="true">
                                            <ng-template kendoTabContent>
                                                <div class="row">
                                                    <div class="col">
                                                        <carrier-contact-grid [carrierID]="editedCarrierList.carrierId"></carrier-contact-grid>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab [title]="viewType == 'RFQ' ? 'RFQs' : 'Orders'">
                                            <ng-template kendoTabContent>
                                                <carrier-sales-loads-offer-grid *ngIf="loads.length>0"
                                                                                [loads]="loads"
                                                                                [viewType]="viewType"
                                                                                [availableLoadsFilter]="availableLoadsFilter"
                                                                                [employees]="employees"
                                                                                [selectedLoad]="quoteOrderLine"
                                                                                (onClick)="loadClick($event)">
                                                </carrier-sales-loads-offer-grid>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab [title]="'Lanes'">
                                            <ng-template kendoTabContent>
                                                <div class="row">
                                                    <div class="col">
                                                        <carrier-lane-grid [carrierID]="editedCarrierList.carrierId"></carrier-lane-grid>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                    </kendo-tabstrip>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Bulk Tender'" *ngIf="isBulkTender==true" [selected]="isBulkTender">
                <ng-template kendoTabContent>
                    <div class="row">
                        <div class="col-sm-1 text-end fw-bold">
                            {{carrierLookupType}}:
                        </div>
                        <div class="col-sm-2">
                            <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupControl'" [placeholder]="'Enter ' + carrierLookupType"
                                              [carrierLookupType]="carrierLookupType" (carrierSelected)="onCarrierChange($event)"></carrier-dropdown>
                        </div>
                        <div class="col fw-bold">
                            <input type="radio" id="carrierLookupMC" name="carrierLookupType" [value]="'MC'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='MC'" (click)="getCarrierLookup('MC')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupMC">MC</label>
                            <input type="radio" id="carrierLookupCode" name="carrierLookupType" [value]="'Code'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='Code'" (click)="getCarrierLookup('Code')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupCode">Code</label>
                            <input type="radio" id="carrierLookupName" name="carrierLookupType" [value]="'Name'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='Name'" (click)="getCarrierLookup('Name')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupName">Name</label>
                            <input type="radio" id="carrierLookupDOT" name="carrierLookupType" [value]="'DOT'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='DOT'" (click)="getCarrierLookup('DOT')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupDOT">DOT</label>
                            <input type="radio" id="carrierLookupMX" name="carrierLookupType" [value]="'MX'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='MX'" (click)="getCarrierLookup('MX')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupMX">MX</label>
                            <input type="radio" id="carrierLookupSCAC" name="carrierLookupType" [value]="'SCAC'" style="margin:5px;transform: scale(1.5);"
                                   [checked]="carrierLookupType=='SCAC'" (click)="getCarrierLookup('SCAC')" />
                            <label style="margin-right:1.0rem;" for="carrierLookupSCAC">SCAC</label>
                        </div>
                    </div>

                    <div class="row" *ngIf="editedCarrierList && (editedCarrierList | json) != '{}'">
                        <div class="col-sm-3">
                            <div class="row p-2">
                                <div class="col-sm-2 fw-bold text-end">Rate</div>
                                <div class="col">
                                    <input [(ngModel)]="editedCarrierList.offerRate" (change)="editedCarrierList.offerRatePerMile=calculateOfferRatePerMile(editedCarrierList.offerRate)" name="offerRate" class="form-control k-input" type="number" step="0.01" /><br />
                                </div>
                            </div>
                            <div class="row p-2">
                                <div class="col text-end">
                                    <button class="btn btn-primary" type="button" (click)="saveOffer()"
                                            [disabled]="isSaving == true || isExcludeNonRMISCertified && !editedCarrierList.isRMISCertified && !searchQuoteOrderLine.isMexicoOnly && !searchQuoteOrderLine.isExcludeRMISCertification">
                                        <i class="fas fa-exclamation-circle text-danger" *ngIf="isExcludeNonRMISCertified && !editedCarrierList.isRMISCertified && !searchQuoteOrderLine.isMexicoOnly && !searchQuoteOrderLine.isExcludeRMISCertification"></i>
                                        Save
                                    </button>
                                    <!--<button class="btn btn-primary" (click)="saveOffer()" [disabled]="isSaving==true">Save</button>-->
                                    <button class="btn btn-secondary" (click)="cancelOffer()">Cancel</button>
                                    <div class="text-danger" *ngIf="isExcludeNonRMISCertified && !editedCarrierList.isRMISCertified && !searchQuoteOrderLine.isMexicoOnly && !searchQuoteOrderLine.isExcludeRMISCertification">
                                        <i class="fas fa-exclamation-circle"></i>
                                        Not RMIS Certified
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="row p-2">
                                <div class="col">
                                    <!--<carrier-geocodelane-detail [carrierID]="editedCarrierList.carrierId" [isBulkTender]="true" (onRefresh)="onCarrierChange($event)"></carrier-geocodelane-detail>-->
                                    <carrier-geocodelane-detail [carrierID]="editedCarrierList.carrierId" [carrier]="editedCarrierList" [isBulkTender]="true" (onRefresh)="onCarrierChange($event)"></carrier-geocodelane-detail>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <h4>Carrier Contacts, Lanes</h4>
                            <div class="row">
                                <div class="col-sm-12">
                                    <kendo-tabstrip>
                                        <kendo-tabstrip-tab [title]="'Contacts'">
                                            <ng-template kendoTabContent>
                                                <div class="row">
                                                    <div class="col">
                                                        <carrier-contact-grid [carrierID]="editedCarrierList.carrierId"></carrier-contact-grid>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                        <kendo-tabstrip-tab [title]="'Lanes'">
                                            <ng-template kendoTabContent>
                                                <div class="row">
                                                    <div class="col">
                                                        <carrier-lane-grid [carrierID]="editedCarrierList.carrierId"></carrier-lane-grid>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                    </kendo-tabstrip>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </div>
</div>
